module.exports = __webpack_public_path__ + "img/icon-gg.19b729f4.png";